export const FALLBACK_IMG =
  "https://imgstatic.phonepe.com/images/stocks/web/1200/630/sm_logo_web_error.png";

export const FALLBACK_IMG_ALT = "Share.Market Blog";

export const OG_IMG =
  "https://share.market/blog/static/default-thumb-70a564dd3b7c94df1878fb5faa3992c6.png";

export const OG_SITE_NAME = "Share.Market";
